/**
 * @freealbum/layouts — layout templates, theme packs, sticker/background catalogues,
 * adjustment presets and the chronological auto-fill.
 *
 * This entry is browser safe — nothing here imports a Node built-in.
 *
 * Anything that needs the filesystem lives in `@freealbum/layouts/node`:
 *   `assetDirs(rootDir?)`          absolute `{ stickers, backgrounds }` directories
 *   `assetPath(kind, id, rootDir?)` absolute path of one SVG
 *   `ASSET_DIRS`                    lazy `assetDirs()` with no root
 * Omit `rootDir` when the caller runs from its real location on disk (worker, scripts, tests).
 * Pass it when the caller is bundled — bundlers rewrite `import.meta.url`, so the module-relative
 * answer is wrong and the explicit root (monorepo root, a `node_modules` parent, or the package
 * directory) is the only reliable one.
 */
export * from './types';
export * from './layouts/index';
export * from './themes';
export * from './assets';
export * from './presets';
export * from './autofill';
export * from './tag-fill';
